/**
 * The player's rich-ending and wallet vocabularies. KUI's ending and wallet types
 * derive from these lists, so the validator and the player cannot drift apart.
 */

export const BACKGROUND_GRADIENTS = [
  'cotton-candy',
  'forest-fire',
  'moody',
  'mystery',
  'ocean-sunrise',
  'pink-ocean',
  'rainbow',
  'river',
  'sky-blue',
  'sunset',
  'tropical',
  'wiggles',
] as const;

/**
 * Wallet-item keys the runtime reads off `walletUpdates` (PHP `WalletItemKey`). A
 * RIASEC quiz saves `raisecProfile` (the "raisec" spelling is the app's, deliberate);
 * an MBTI quiz saves `myersBriggsProfile` or `unifiedPersonalityAcronym`; a
 * work-values quiz saves `superWorkValues`; a self-efficacy quiz saves `selfEfficacy`
 * (`<level>-<source>`, e.g. `strong-mastery`); a career adaptability quiz saves
 * `careerAdaptability` (`concern`, `control`, `curiosity`, `confidence` or `balanced`).
 */
export const WALLET_KEYS = [
  'raisecProfile',
  'myersBriggsProfile',
  'unifiedPersonalityAcronym',
  'superWorkValues',
  'selfEfficacy',
  'careerAdaptability',
] as const;

/** Wallet keys with a dedicated result renderer; an `ending:wallet` on any other key shows the generic fallback. */
export const RENDERER_WALLET_KEYS = [
  'raisecProfile',
  'myersBriggsProfile',
  'superWorkValues',
  'selfEfficacy',
  'careerAdaptability',
] as const satisfies readonly WalletKey[];

export const CARD_COLORS = [
  'blue',
  'coral',
  'error',
  'information',
  'orange',
  'pink',
  'purple',
  'yellow',
] as const;

/** A small icon set, distinct from the much larger hero illustration set. */
export const CARD_ILLUSTRATIONS = [
  'ai-brain',
  'eye',
  'favourite-circle',
  'legal-hammer',
  'stars',
  'user-love',
  'zap',
] as const;

export type BackgroundGradient = (typeof BACKGROUND_GRADIENTS)[number];
export type WalletKey = (typeof WALLET_KEYS)[number];
export type RendererWalletKey = (typeof RENDERER_WALLET_KEYS)[number];
export type CardColor = (typeof CARD_COLORS)[number];
export type CardIllustration = (typeof CARD_ILLUSTRATIONS)[number];
